import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/** Canonical oppositions list (staff view: includes disabled ones). */
export function useOppositions() {
    return useQuery({
        queryKey: ['oppositions'],
        queryFn: () => apiClient('/oppositions'),
        staleTime: 1000 * 60 * 30,
    });
}
//# sourceMappingURL=useOppositions.js.map